import { userWizardOps } from "../api/operations";
import { entityFactory } from "../hooks/useEntity";
import { ROLE } from "../Auth/useRole";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("flows"),
  endpoint: "user-wizard",
  operations: userWizardOps,
  roleView: [ROLE.CUSTOMER_ADMIN],
  roleAdmin: [ROLE.CUSTOMER_ADMIN],
  singularName: (t) => t("Flow"),
  name: (t) => t("Flows"),
  disableCache: true,
  keepPreviousData: true,
});

export default conf;
